import styled from 'styled-components';
import { Button, ButtonProps } from 'antd';

export const IconButton = styled(Button)<ButtonProps>`
  background-color: #f5f5f5;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 8px;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;

  &:hover {
    background-color: #e8e8e8;
    border-color: #bfbfbf;
  }
`;
